/**
 * Engage embed "Powered by" branding link (TSAI uiController.js `.branding` parity).
 *
 * Do-follow link to scale2rev.com with UTMs so GA4 attributes landings to the
 * embedding host via `utm_content` (customer hostname).
 */

export const WIDGET_POWERED_BY_LANDING_ORIGIN = 'https://scale2rev.com';

export const WIDGET_POWERED_BY_UTM = {
  source: 'widget',
  medium: 'embed',
  campaign: 'powered_by',
} as const;

export const WIDGET_POWERED_BY_LINK_LABEL = 'Scale2Rev.com';

/** Build the marketing landing URL with standard widget UTMs. */
export function buildWidgetPoweredByHref(embedHost?: string | null): string {
  const url = new URL('/', WIDGET_POWERED_BY_LANDING_ORIGIN);
  url.searchParams.set('utm_source', WIDGET_POWERED_BY_UTM.source);
  url.searchParams.set('utm_medium', WIDGET_POWERED_BY_UTM.medium);
  url.searchParams.set('utm_campaign', WIDGET_POWERED_BY_UTM.campaign);
  const host = embedHost?.trim();
  if (host) {
    url.searchParams.set('utm_content', host);
  }
  return url.toString();
}

/** Hostname of the page embedding the widget (undefined in SSR). */
export function resolveWidgetEmbedHostname(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const host = window.location.hostname?.trim();
  return host || undefined;
}
